const categories = {
  "skincare": ['cleanser', 'moisturiser', 'sun protection', 'masks', 'tools'],
  "treatments": ['anti-ageing', 'brightening', 'calming', 'exfoliating', 'hydrating'],
  "beauty": ['complexion', 'concealer', 'cheeks', 'eyes + brows', 'nails', 'tools'],
  "body-tanning": ['cleanse & exfoliate', 'moisturiser', 'tanning'],
  //"gifts": [],
}

export default categories
